/**
 * Generate an array of language strings for headings that can be passed into the template.
 *
 * @param {object} data
 *
 * @returns {string[]}
 */
const generateHeadings = (data) => {
    let headings = [];
    if (data.headings) {
        headings = data.headings;
    }
    if (data.isDuplicate) {
        headings.push('RECEIPT.DUPLICATE');
    }
    if (data.isBalancePayment) {
        headings.push('RECEIPT.BALANCE_PAYMENT');
    }

    return [...new Set(headings)];
};

module.exports = {
    generateHeadings,
};
